import { HealthQuestionsWeightHeight } from '../pages/steps/questions/health-questions-weight-height';
import { makeQuestionBuilder } from './utils';

const healthQuestionBuilder = makeQuestionBuilder(
  'health',
  'healthQuestion',
  'page.health-questions',
);

export const healthQuestions = [
  {
    props: {
      name: 'allergies',
      details: true,
      progress: 0.53,
    },
  },
  {
    component: HealthQuestionsWeightHeight,
    props: {
      name: 'weightHeight',
      progress: 0.56,
    },
  },
  {
    props: {
      name: 'metalImplants',
      details: true,
      progress: 0.59,
    },
  },
  {
    props: {
      name: 'diabetes',
      options: ['no', 'yes-type-1', 'yes-type-2'],
      secondaryOptions: { 'yes-type-2': ['diet-controlled', 'tablets', 'insulin'] },
      progress: 0.62,
    },
  },
  {
    props: {
      name: 'highBloodPressure',
      progress: 0.65,
    },
  },
  {
    props: {
      name: 'arrhythmias',
      details: true,
      progress: 0.68,
    },
  },
  {
    props: {
      name: 'pacemaker',
      secondaryOptions: { yes: ['pacing', 'defibrillator', 'not-sure'] },
      progress: 0.71,
    },
  },
  {
    props: {
      name: 'bloodThinningMedication',
      details: true,
      progress: 0.74,
    },
  },
  {
    props: {
      name: 'heartConditions',
      details: true,
      progress: 0.77,
    },
  },
  {
    props: {
      name: 'stroke',
      details: true,
      progress: 0.8,
    },
  },
  {
    props: {
      name: 'epilepsy',
      details: true,
      progress: 0.83,
    },
  },
  {
    props: {
      name: 'obstructiveSleepApnoea',
      details: true,
      progress: 0.845,
    },
  },
  {
    props: {
      name: 'asthmaLungConditions',
      details: true,
      progress: 0.86,
    },
  },
  {
    props: {
      name: 'digestiveConditions',
      details: true,
      progress: 0.89,
    },
  },
  {
    props: {
      name: 'bloodProblems',
      details: true,
      progress: 0.9,
    },
  },
  {
    props: {
      name: 'organTransplant',
      details: true,
      progress: 0.91,
    },
  },
  {
    props: {
      name: 'cancerTreatment',
      details: true,
      progress: 0.92,
    },
  },
  {
    props: {
      name: 'infectiousDiseases',
      details: true,
      progress: 0.95,
    },
  },
  {
    props: {
      name: 'pregnancy',
      details: true,
      progress: 0.98,
    },
  },
  {
    props: {
      name: 'otherHealthConditions',
      details: true,
      progress: 0.99,
    },
  },
  {
    props: {
      name: 'glp1Medications',
      details: true,
      progress: 0.995,
    },
  },
]
  // TODO: ideally we would do this at build time.
  .map(healthQuestionBuilder);
